import type { Lang, LorsCopy } from "./translations";

export type Nov19Headline = { headline: string; subhead: string };

export const nov19Headlines: Nov19Headline[] = [
  {
    headline: "Leave your family the house, not 12–18 months of court dates.",
    subhead:
      "Free webinar on November 19th at 12:00 PM PT with attorney Ruby Steinbrecher.",
  },
  {
    headline:
      "An online form and good intentions aren’t a plan. Learn what actually protects your home.",
    subhead:
      "Join attorney Ruby Steinbrecher on November 19th for a plain-English hour on wills, trusts, and probate.",
  },
  {
    headline:
      "In California, probate can quietly eat into what you leave behind. Here’s how to avoid it.",
    subhead:
      "We’ll walk through California probate costs and how a funded trust protects your home. November 19th.",
  },
  {
    headline:
      "Who gets your house is the easy part. How they get it is where families get stuck.",
    subhead:
      "Attorney Ruby Steinbrecher explains the difference between a will and a funded trust. Free webinar, November 19th.",
  },
  {
    headline:
      "A will alone doesn’t keep your home out of probate court. Here’s what does.",
    subhead:
      "Free webinar on November 19th at 12:00 PM PT. Reserve your spot in a minute.",
  },
  {
    headline:
      "Why do so many Sonoma County families end up in probate? Usually one missing step.",
    subhead:
      "Find out what that step is at our free webinar on November 19th at 12:00 PM PT.",
  },
  {
    headline:
      "The kindest thing you can leave your kids is a home with the paperwork already done.",
    subhead:
      "A practical, no-pressure session with attorney Ruby Steinbrecher on November 19th.",
  },
  {
    headline:
      "Most Sonoma County homes are valuable enough to trigger probate. Find out where yours stands.",
    subhead:
      "Free webinar on November 19th at 12:00 PM PT with attorney Ruby Steinbrecher.",
  },
  {
    headline: "One lunch hour now can save your family a year in court later.",
    subhead:
      "Join us at noon PT on November 19th for a free, no-pressure estate planning session.",
  },
  {
    headline:
      "Will or trust? The real question is whether your family ends up in court.",
    subhead:
      "Attorney Ruby Steinbrecher covers wills, trusts, and probate without the jargon. Free webinar, November 19th.",
  },
];

const baseEn = {
  eyebrow: "Free Estate Planning Webinar",
  headline: nov19Headlines[0].headline,
  headlineBreakBefore: "",
  subhead: nov19Headlines[0].subhead,
  subheadLabel: "A note from Ruby:",
  learnTitle: "What Most Families Don't Realize Until It's Too Late",
  learnItems: [
    "How wills, living trusts, and powers of attorney each work in California",
    "How a properly funded living trust can help a family pass assets without probate court",
    "What California's probate process generally looks like — timelines, court involvement, and typical costs",
    "Practical first steps for putting an estate plan in place, and the questions to ask before you do",
  ],
  quote:
    "Ruby Steinbrecher was fantastic. The family trust workshop was clear, informative, and extremely helpful for getting started with estate planning.",
  quoteAttribution: "Shawn H., Workshop Attendee",
  formDate: { short: "Thu, November 19th", long: "Thursday, November 19th" },
  formTime: "12:00 PM PT",
  formVenueLine1: "Live Online Webinar",
  formVenueLine2: "Join from anywhere — link sent after registration",
  formTitle: "Reserve Your Seat",
  formSubtitle: "Free to attend. Limited seating available.",
  formFirstName: "First name",
  formLastName: "Last name",
  formEmail: "Email",
  formPhone: "Phone",
  formSmsConsent:
    "I consent to receive text messages from the Law Office of Ruby Steinbrecher about this event, and occasional marketing messages. Message & data rates may apply. Text HELP for assistance, reply STOP to opt out.",
  formEnewsConsent:
    "I'd like to receive occasional email updates from the Law Office of Ruby Steinbrecher.",
  formPrivacy: "Privacy Policy",
  formSubmit: "Reserve My Seat",
  formSubmitting: "Reserving your seat…",
  formTrust: "⭐ Trusted by local families | 81 Five-Star Reviews",
  getDirections: "",
  footerCopyright: "© 2026 Ruby Steinbrecher",
  footerPrivacy: "Privacy Policy",
  testimonialsTitle: "What Families Are Saying",
  aboutTitle: "Meet Ruby Steinbrecher",
  aboutRole: "Attorney",
  aboutBody: [
    "I have practiced law since 2007, first working at a medium-sized firm in San Francisco handling civil litigation, and then moving into estate planning, small business and contract law since 2010. I value people, the planet, and prosperity that does not adversely affect the former.",
    "Prior to entering the legal field, I had a variety of business and life experience that has only enhanced my ability to serve clients: Road Manager for Ken Kesey\'s bus trip to Great Britain in 1999, Human Resources at a tech startup in 2001, recognized for my work as a Case Manager at Casey Family Programs with disadvantaged youth in the foster care system in Oakland and the wider San Francisco-Bay Area in the early 2000\'s.",
    "Currently, I live in Sebastopol with my daughter, husband, and a menagerie of pets, where I enjoy gardening as it keeps me grounded and enjoying the beautiful weather.",
  ],
  registrationTitle: "Ready to Secure Your Family's Future?",
  registrationSub: "Free to attend. Limited seating available.",
  registrationCta: "Save My Seat",
  registrationFoot:
    "No pressure. Just clear information so you can make the right decision for your family.",
  errorTitle: "Something went wrong",
  errorBody:
    "We couldn't reserve your seat. Please try again or call our office.",
  validation: {
    firstName: "First name is required",
    lastName: "Last name is required",
    email: "Enter a valid email",
    phone: "Enter a valid phone number",
  },
  timeAgo: {
    monthAgo: "a month ago",
    monthsAgo: (n: number) => `${n} months ago`,
    yearAgo: "a year ago",
  },
};

export const lorsContentNov19 = { en: baseEn, es: baseEn } as unknown as Record<Lang, LorsCopy>;

export const getNov19Copy = (hParam: string | null): LorsCopy => {
  const n = Number(hParam);
  const idx = Number.isInteger(n) && n >= 1 && n <= nov19Headlines.length ? n - 1 : 0;
  const pick = nov19Headlines[idx];
  return { ...baseEn, headline: pick.headline, subhead: pick.subhead } as unknown as LorsCopy;
};
